export default "__VITE_ASSET__BKTRZ3qs__"